import type { RouteRecordRaw } from 'vue-router';

export const teamsRoute: RouteRecordRaw = {
  path: '/settings/teams',
  name: 'Teams',
  component: () => import('./pages/TeamsPage.vue'),
  meta: {
    title: 'Teams',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('dt:core:teams:list'),
  },
};

export const teamRoute: RouteRecordRaw = {
  path: '/settings/teams/:id',
  name: 'Team',
  component: () => import('./pages/TeamPage.vue'),
  meta: {
    title: 'Team',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('dt:core:teams:list'),
  },
};
